import './SocialShareMenu.scss';

import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import MenuButton from 'components/clickables/MenuButton';

import cxHelpers from 'util/className';
import { copyContentToClipboard, openWindow } from 'util/dom';
import { toI18n } from 'util/i18n';
import { logHiringEvent, trackUxEvent } from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';

@cxHelpers('SocialShareMenu')
export default class SocialShareMenu extends PureComponent {
  static propTypes = {
    placement: PropTypes.string.isRequired,
    entity: PropTypes.instanceOf(Map).isRequired,
    children: PropTypes.node.isRequired,
    onCopy: PropTypes.func.isRequired,
    productLocation: PropTypes.string,
    menuItemClassname: PropTypes.string,
    facebookLink: PropTypes.string.isRequired,
  };

  menuButtonOptions = [
    {
      value: toI18n('social_share.facebook'),
      image: require('./images/facebook.png'),
    },
    {
      value: toI18n('social_share.twitter'),
      image: require('./images/twitter.png'),
    },
    {
      value: toI18n('social_share.linkedin'),
      image: require('./images/linkedin.png'),
    },
    {
      value: toI18n('social_share.copy_link'),
      icon: 'link',
    },
  ];

  onMenuItemSelected = value => {
    const { entity } = this.props;
    let clicked;

    if (value === toI18n('social_share.facebook')) {
      clicked = 'facebook';
      this.handleFacebookShare();
    } else if (value === toI18n('social_share.twitter')) {
      clicked = 'twitter';
      openWindow(entity.get('twitter_share_link'));
    } else if (value === toI18n('social_share.linkedin')) {
      clicked = 'linkedin';
      openWindow(entity.get('linkedin_share_link'));
    } else {
      clicked = 'copy';
      this.copyLink();
    }

    this.trackSelection(clicked);
  };

  handleFacebookShare() {
    // eslint-disable-next-line no-undef
    if (window.FB && typeof window.FB.ui === 'function') {
      window.FB.ui({
        method: 'feed',
        display: 'popup',
        link: this.props.facebookLink,
      });
    } else {
      // fallback to opening the share link directly when the SDK is unavailable
      // eslint-disable-next-line no-console
      console.error('Facebook SDK unavailable, opening share link directly');
      openWindow(this.props.facebookLink);
    }
  }

  copyLink = () => {
    copyContentToClipboard(this.copyableEl);

    this.props.onCopy();
  };

  trackSelection = clicked => {
    const { productLocation } = this.props;

    logHiringEvent({
      product_location: 'share_button',
      action: 'shared_link',
      additional_data: { productLocation, clicked },
    });

    trackUxEvent({
      productArea: PRODUCT_AREAS.HIRING,
      eventCategory: EVENT_CATEGORIES.HOMEBASE_NATIVE_JOB,
      eventAction: EVENT_ACTIONS.LINK_CLICKED,
      actionType: TRACK_ACTION_TYPES.CLICK,
      properties: {
        element: clicked,
      },
    });
  };

  setCopyableEl = copyableEl => (this.copyableEl = copyableEl);

  render() {
    const { placement, entity, children, menuItemClassname } = this.props;

    return (
      <MenuButton
        className={this.cx()}
        options={this.menuButtonOptions}
        onSelection={this.onMenuItemSelected}
        placement={placement}
        menuItemClassname={menuItemClassname}
      >
        {children}
        <span className={this.cxEl('copyable-link')} ref={this.setCopyableEl}>
          {entity.get('full_url')}
        </span>
      </MenuButton>
    );
  }
}
